export default __webpack_public_path__ + "static/0108-eb80e010e7dd51028a3b7daaad87aacd.png";